import React, { useState } from "react";
import { Link } from "react-router-dom";
import './Menu.css'; // Your updated styles

const Menu = ({ isLoggedIn, onLogout, isEnabled}) => {
  // State to control the menu toggle in mobile
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const minimizeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="menu">
      {/* Hamburger button on mobile */}
      <button className="menu-toggle" onClick={toggleMenu}>
        {isMenuOpen ? "✖" : "☰"} {/* Show ✖ for close, ☰ for hamburger */}
      </button>
      
      {/* Menu items */}
      <ul className={`menu-items ${isMenuOpen ? "menu-open" : ""}`}>
        {!isLoggedIn ? (
          <>
            <li><Link to="/login"                                  
                 style={{ pointerEvents: isEnabled ? 'auto' : 'none', color: isEnabled?"#007bff":"#cccccc" }}   
                 onClick={minimizeMenu}                 
                  >
                    Login
                </Link>
            </li>
            <li><Link to="/signup"                  
                  style={{ pointerEvents: isEnabled ? 'auto' : 'none', color: isEnabled?"#007bff":"#cccccc" }}                  
                  onClick={minimizeMenu}
                >
                  Sign Up
                </Link>
            </li>
          </>
        ) : (
          <>
            <li><Link to="/create-template"              
              style={{ pointerEvents: isEnabled ? 'auto' : 'none', color: isEnabled?"#007bff":"#cccccc" }}                  
              onClick={minimizeMenu}
            >
              AIT Editor
            </Link></li>
            <li><Link to="/dashboard"              
              style={{ pointerEvents: isEnabled ? 'auto' : 'none', color: isEnabled?"#007bff":"#cccccc" }}                  
              onClick={minimizeMenu}
            >
              Files
            </Link></li>
{/*
            <li><Link to="/help"              
              style={{ pointerEvents: isEnabled ? 'auto' : 'none', color: isEnabled?"#007bff":"#cccccc" }}                  
              onClick={minimizeMenu}
            >              
              Help
            </Link></li>
*/}
            <li><Link to="/settings"                      
                     style={{ pointerEvents: isEnabled ? 'auto' : 'none', color: isEnabled?"#007bff":"#cccccc" }}
                     onClick={minimizeMenu}
                  >
                    Settings
                </Link>
            </li>

            <li><Link to="/licenses"                      
                     style={{ pointerEvents: isEnabled ? 'auto' : 'none', color: isEnabled?"#007bff":"#cccccc" }}
                     onClick={minimizeMenu}
                  >
                    Licenses
                </Link>
            </li>

            <li className="logout-btn">
              <button onClick={onLogout}>Logout</button>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
};

export default Menu;

